import { render, staticRenderFns } from "./StatisticsNumber.vue?vue&type=template&id=6d29776a&"
import script from "./StatisticsNumber.vue?vue&type=script&lang=js&"
export * from "./StatisticsNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports